import { AccountStatementResponse } from '../../account-statement/types/account-statement.type'

export enum PROFIT_AND_LOSS_DATE_RANGES {
	TODAY,
	YESTERDAY,
	SEVEN_DAYS,
	FIFTEEN_DAYS,
	THREE_MONTHS,
	DATE_RANGE,
}

export interface ProfitAndLossSport {
	id: string
	name: string
	items: ProfitAndLossMarket[]
}

export interface ProfitAndLossMarket {
	id: string
	name: string
	marketType: string
	items: AccountStatementResponse[]
}
